module.exports = __webpack_public_path__ + "static/3T8A9289-800x500-4b1f90dce81a4a29c3078cef9a059d9d.jpg";